/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Fisify API
 * OpenAPI spec version: 1.0.0
 */

export type ExerciseType = typeof ExerciseType[keyof typeof ExerciseType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExerciseType = {
  BREATHING: 'BREATHING',
  ECCENTRIC_ACTIVATION: 'ECCENTRIC_ACTIVATION',
  FUNCTIONAL_ACTIVATION: 'FUNCTIONAL_ACTIVATION',
  ISOMETRIC_ACTIVATION: 'ISOMETRIC_ACTIVATION',
  CONCENTRIC_ACTIVATION: 'CONCENTRIC_ACTIVATION',
  ISOTONIC_ACTIVATION: 'ISOTONIC_ACTIVATION',
  MOBILITY: 'MOBILITY',
  MOTOR_CONTROL: 'MOTOR_CONTROL',
  MYOFASCIAL_RELEASE: 'MYOFASCIAL_RELEASE',
  NEURAL_SLIDING: 'NEURAL_SLIDING',
  PROPRIOCEPTION: 'PROPRIOCEPTION',
  STABILITY: 'STABILITY',
  STRETCHING: 'STRETCHING',
  TRACTION: 'TRACTION',
  OFFICE: 'OFFICE',
  JUMP: 'JUMP',
  RUNNING_TECHNIQUE: 'RUNNING_TECHNIQUE',
  AEROBIC: 'AEROBIC',
  NEURAL_MOBILITY: 'NEURAL_MOBILITY',
} as const;
